import moment from "moment/moment.js";
import 'moment/locale/pt-br';
import React, { useState, useEffect } from "react";
import { toast as alert } from "react-toastify";
import ComAberturaJuntaBNF from "../../components/Emails/ComAberturaJuntaBNF.js";
import ComAberturaJuntaPA from "../../components/Emails/ComAberturaJuntaPA.js";
import ComDecisaoJuntaBNF from "../../components/Emails/ComDecisaoJuntaBNF.js";
import ComDecisaoJuntaPA from "../../components/Emails/ComDecisaoJuntaPA.js";
import ComEscolhaAbstencaoBNF from "../../components/Emails/ComEscolhaAbstencaoBNF.js";
import ComEscolhaAbstencaoPA from "../../components/Emails/ComEscolhaAbstencaoPA.js";
import ComEscolhaBNF from "../../components/Emails/ComEscolhaBNF.js";
import ComEscolhaPA from "../../components/Emails/ComEscolhaPA.js";
import ParOpiniaoEspecializada from "../../components/Emails/ParOpiniaoEspecializada.js";
import ParTecnicoConclusivo from "../../components/Emails/ParTecnicoConclusivo.js";
import SolExamesComplementaresBNF from "../../components/Emails/SolExamesComplementaresBNF.js";
import SolExamesComplementaresOPS from "../../components/Emails/SolExamesComplementaresOPS.js";
import ValConsensoParcial from "../../components/Emails/ValConsensoParcial.js";
import config from "../../config/config.js";
import business, { api } from "../../services/business.js";
import tools from "../../lib/tools.js";
import Loading from "../../components/Loading.js";
import { useParams } from "react-router-dom";
import ComRecusaConsensoPA from "../../components/Emails/ComRecusaConsensoPA.js";
import '../../assets/styles/pages/Dossie.scss';
import ComConsensoTecnicoOPS from "../../components/Emails/ComConsensoTecnicoOPS.js";
import ComConsensoTecnicoPA from "../../components/Emails/ComConsensoTecnicoPA.js";
import ComConsensoTecnicoBNF from "../../components/Emails/ComConsensoTecnicoBNF.js";

export default function DocDossie() {
    let { id_processo, id_processo_etapa_status } = useParams();
    document.title = 'säästo';

    const [notificacao, setNotificacao] = useState([]);
    const [historico, setHistorico] = useState([]);
    const [anexos, setAnexos] = useState([]);
    const [parecer, setParecer] = useState({});
    const [loading, setLoading] = useState(false);
    const [viewingIndex, setViewingIndex] = useState(null);

    const viewFile = async (anexo, index) => {
        setViewingIndex(index);
        const data = await api.get(`${anexo.url}${anexo.extensao === 'zip' ? '/download' : ''}`);
        if (data.data.response === false) {
            alert.error("Não foi possível abrir o arquivo.");
        } else {
            window.open(data.data.response, "_blank");
        }
        setViewingIndex(null);
    }

    useEffect(() => {
        setLoading(true);
        async function getProcess() {
            setNotificacao(await business.getDossie(id_processo));
            setHistorico(await business.getDossieHistorico(id_processo));
            setAnexos(await business.getDossieAnexos(id_processo));
            setParecer(await business.getDossieParecer(id_processo));
            setLoading(false);
        }

        getProcess();
    }, [id_processo]);

    const registro_historico = (historico || []).map((h) => {
        return {
            texto: h.desc_acao,
            data: moment(h.data_criacao).format('DD/MM/YYYY HH:mm:ss'),
            desc_processo_etapa: h.desc_processo_etapa,
            desc_processo_etapa_status: h.desc_processo_etapa_status
        };
    });

    const registro_comunicacoes = (notificacao || []).map((c) => {
        return {
            texto: c?.desc_conteudo,
            data_disparo: moment(c?.data_cadastro).format('DD/MM/YYYY HH:mm:ss'),
            data_format: moment(c?.data_cadastro).format('DD/MM/YYYY'),
            data_leitura: c?.data_leitura && moment(c?.data_leitura).format('DD/MM/YYYY HH:mm:ss'),
            codigo: c?.id + c?.processo?.disparo?.id_protocolo,
            id_notificacao_canal: c?.id_notificacao_canal,
            id_notificacao_conteudo: c?.id_notificacao_conteudo,
            desc_processo_etapa: c?.processo?.disparo?.desc_processo_etapa,
            canal: c?.desc_canal,
            receptorBNF: c?.id_beneficiario,
            receptorPA: c?.id_profissional,
            receptorOPS: c?.id_operadora,
            canalBNF: (c?.id_notificacao_canal === '2'
                ? c?.processo?.disparo?.beneficiario?.email
                : c?.processo?.disparo?.beneficiario?.telefone?.replace(/(\d{2})(\d{4})(\d{4,5})$/, "($1) $2-$3")),
            canalPA: (c?.id_notificacao_canal === '2'
                ? c?.processo?.disparo?.profissional?.email
                : c?.processo?.disparo?.profissional?.telefone?.replace(/(\d{2})(\d{4})(\d{4,5})$/, "($1) $2-$3")),
            canalOPS: (c?.id_notificacao_canal === '2'
                ? c?.processo?.disparo?.endereco_operadora?.email
                : c?.processo?.disparo?.endereco_operadora?.telefone?.replace(/(\d{2})(\d{4})(\d{4,5})$/, "($1) $2-$3")),
            disparo: (c?.id_notificacao_canal === '2'
                ? 'sistema@saasto.com.br'
                : '(48) 9199-9368 (Whatsapp säästö)'),
            ip: c?.ip,
            navegador: c?.navegador,
            sistema_operacional: c?.sistema_operacional,
            processo: {
                protocolo: c?.processo?.disparo?.id_protocolo,
                operadora_nome: c?.processo?.disparo?.desc_operadora,
                operadora_endereco:
                    c?.processo?.disparo?.endereco_operadora?.logradouro +
                    ', ' +
                    c?.processo?.disparo?.endereco_operadora?.numero +
                    ', ' +
                    c?.processo?.disparo?.endereco_operadora?.bairro +
                    ', ' +
                    c?.processo?.disparo?.endereco_operadora?.cidade +
                    ' - ' +
                    c?.processo?.disparo?.endereco_operadora?.uf,
                operadora_telefone: c?.processo?.disparo?.endereco_operadora?.telefone2
                    ? c?.processo?.disparo?.endereco_operadora?.telefone2.replace(/(\d{4})(\d{3})(\d{4})$/, "$1 $2 $3")
                    : c?.processo?.disparo?.endereco_operadora?.telefone?.replace(/(\d{2})(\d{4})(\d{4,5})$/, "($1) $2-$3"),
                operadora_imagem: c?.processo?.disparo?.endereco_operadora?.imagem,
                data_disparo: moment(config.dataHoraAtual()).format('LL'),
                profissional_nome: c?.processo?.disparo?.profissional?.nome,
                profissional_crmcro: c?.processo?.disparo?.profissional?.crm,
                profissional_uf: c?.processo?.disparo?.profissional?.uf,
                profissional_telefone: c?.processo?.disparo?.profissional?.telefone?.replace(/(\d{2})(\d{4})(\d{4,5})$/, "($1) $2-$3"),
                data_atendimento: moment(c?.processo?.disparo?.data_atendimento).format('DD/MM/YYYY'),
                beneficiario_nome: c?.processo?.disparo?.beneficiario?.nome,
                beneficiario_cpf: c?.processo?.disparo?.beneficiario?.cpf,
                beneficiario_sexo: c?.processo?.disparo?.beneficiario?.sexo === 'M' ? 'masculino' : 'feminino',
                beneficiario_guia: c?.processo?.disparo?.guia,
                beneficiario_nascimento: c?.processo?.disparo?.beneficiario?.nascimento,
                beneficiario_idade: tools.calcularIdade(c?.processo?.disparo?.beneficiario?.nascimento),
                auditor_nome: c?.processo?.disparo?.auditor?.nome,
                auditor_crmcro: c?.processo?.disparo?.auditor?.crm,
                auditor_uf: c?.processo?.disparo?.auditor?.uf,
                assistente_responsavel_nome: c?.processo?.disparo?.responsaveis?.nome_assistente,
                enfermeira_responsavel_nome: c?.processo?.disparo?.responsaveis?.nome_enfermeira,
                desempatador_responsavel_nome: c?.processo?.disparo?.responsaveis?.nome_desempatador,
                desempatador_responsavel_crmcro:
                    c?.processo?.disparo?.responsaveis?.crm_desempatador ||
                    c?.processo?.disparo?.responsaveis?.cro_desempatador,
                desempatador_responsavel_uf:
                    c?.processo?.disparo?.responsaveis?.crm_uf_desempatador ||
                    c?.processo?.disparo?.responsaveis?.cro_uf_desempatador,
                desempatador_responsavel_laudo: c?.processo?.disparo?.texto_parecer,
                data_parecer: moment(c?.processo?.disparo?.data_validacao).format('LL'),
                data_parecer_min: moment(c?.processo?.disparo?.data_validacao).format('DD/MM/YYYY'),
                procedimentos: (c?.processo?.disparo?.procedimentos || []).map((p) => {
                    return {
                        id: p.id_procedimento,
                        codigo: p?.codigo || '-',
                        descricao: p.desc_procedimento,
                        quantidade_solicitada: p.quantidade_solicitada || 0,
                        quantidade_autorizada: p.quantidade_aprovada || 0,
                        quantidade_pos_analise: p.quantidade_pos_analise || 0,
                        id_divergencia: p.id_processo_motivo_divergencia,
                        divergencia: p?.desc_processo_motivo_divergencia || '-',
                        justificativa: p.observacao || '-',
                        justificativa_pos_analise: p.justificativa_analise || '-'
                    };
                }),
                materiais: (c?.processo?.disparo?.materiais || []).map((m) => {
                    return {
                        id: m.id_material,
                        descricao: m.desc_material,
                        quantidade_solicitada: m.quantidade_solicitada || 0,
                        quantidade_autorizada: m.quantidade_aprovada || 0,
                        quantidade_pos_analise: m.quantidade_pos_analise || 0,
                        id_divergencia: m.id_processo_motivo_divergencia,
                        divergencia: m?.desc_processo_motivo_divergencia || '-',
                        justificativa: m.observacao || '-',
                        justificativa_pos_analise: m.justificativa_analise || '-'
                    };
                }),
                desempatadores: c?.processo?.disparo?.desempatadores,
                id_desempatador: c?.processo?.disparo?.responsaveis?.id_desempatador || 0,
                notificacao_envio: c?.processo?.disparo?.notificacao_envio || {},
                exames_complementares: [],
                conclusao: c?.processo?.processo_conclusao
            }
        };
    });

    const registro_anexos = (anexos || []).map((a) => {
        return {
            tipo: a.anexo_tipo,
            canal: a.anexo_canal,
            data: moment(a.data_leitura).format('DD/MM/YYYY HH:mm:ss'),
            url: a.url,
            nome: a.nome,
            extensao: a.extensao,
            identificador: a.identificador,
            enviado_pa: parseInt(a.enviado_pa) === 1 ? 'Profissional assistente encaminhou um novo documento após a abertura do processo de junta.' : '',
        };
    });
    const parecerItem = parecer[0];
    const registro_parecer = parecer ? {
        texto: parecerItem?.desc_conteudo,
        data_disparo: moment(parecerItem?.data_cadastro).format('DD/MM/YYYY HH:mm:ss'),
        data_format: moment(parecerItem?.data_cadastro).format('DD/MM/YYYY'),
        data_leitura: parecerItem?.data_leitura && moment(parecerItem?.data_leitura).format('DD/MM/YYYY HH:mm:ss'),
        codigo: parecerItem?.id + parecerItem?.processo?.disparo?.id_protocolo,
        id_notificacao_canal: parecerItem?.id_notificacao_canal,
        id_notificacao_conteudo: parecerItem?.id_notificacao_conteudo,
        desc_processo_etapa: parecerItem?.processo?.disparo?.desc_processo_etapa,
        canal: parecerItem?.desc_canal,
        receptorBNF: parecerItem?.id_beneficiario,
        receptorPA: parecerItem?.id_profissional,
        receptorOPS: parecerItem?.id_operadora,
        canalBNF: (parecerItem?.id_notificacao_canal === '2'
            ? parecerItem?.processo?.disparo?.beneficiario?.email
            : parecerItem?.processo?.disparo?.beneficiario?.telefone?.replace(/(\d{2})(\d{4})(\d{4,5})$/, "($1) $2-$3")),
        canalPA: (parecerItem?.id_notificacao_canal === '2'
            ? parecerItem?.processo?.disparo?.profissional?.email
            : parecerItem?.processo?.disparo?.profissional?.telefone?.replace(/(\d{2})(\d{4})(\d{4,5})$/, "($1) $2-$3")),
        canalOPS: (parecerItem?.id_notificacao_canal === '2'
            ? parecerItem?.processo?.disparo?.endereco_operadora?.email
            : parecerItem?.processo?.disparo?.endereco_operadora?.telefone?.replace(/(\d{2})(\d{4})(\d{4,5})$/, "($1) $2-$3")),
        disparo: (parecerItem?.id_notificacao_canal === '2'
            ? 'sistema@saasto.com.br'
            : '(48) 9199-9368 (Whatsapp säästö)'),
        ip: parecerItem?.ip,
        navegador: parecerItem?.navegador,
        sistema_operacional: parecerItem?.sistema_operacional,
        processo: {
            protocolo: parecerItem?.processo?.disparo?.id_protocolo,
            operadora_nome: parecerItem?.processo?.disparo?.desc_operadora,
            operadora_endereco:
                parecerItem?.processo?.disparo?.endereco_operadora?.logradouro +
                ', ' +
                parecerItem?.processo?.disparo?.endereco_operadora?.numero +
                ', ' +
                parecerItem?.processo?.disparo?.endereco_operadora?.bairro +
                ', ' +
                parecerItem?.processo?.disparo?.endereco_operadora?.cidade +
                ' - ' +
                parecerItem?.processo?.disparo?.endereco_operadora?.uf,
            operadora_telefone: parecerItem?.processo?.disparo?.endereco_operadora?.telefone2
                ? parecerItem?.processo?.disparo?.endereco_operadora?.telefone2.replace(/(\d{4})(\d{3})(\d{4})$/, "$1 $2 $3")
                : parecerItem?.processo?.disparo?.endereco_operadora?.telefone?.replace(/(\d{2})(\d{4})(\d{4,5})$/, "($1) $2-$3"),
            operadora_imagem: parecerItem?.processo?.disparo?.endereco_operadora?.imagem,
            data_disparo: moment(config.dataHoraAtual()).format('LL'),
            profissional_nome: parecerItem?.processo?.disparo?.profissional?.nome,
            profissional_crmcro: parecerItem?.processo?.disparo?.profissional?.crm,
            profissional_uf: parecerItem?.processo?.disparo?.profissional?.uf,
            profissional_telefone: parecerItem?.processo?.disparo?.profissional?.telefone?.replace(/(\d{2})(\d{4})(\d{4,5})$/, "($1) $2-$3"),
            data_atendimento: moment(parecerItem?.processo?.disparo?.data_atendimento).format('DD/MM/YYYY'),
            beneficiario_nome: parecerItem?.processo?.disparo?.beneficiario?.nome,
            beneficiario_cpf: parecerItem?.processo?.disparo?.beneficiario?.cpf,
            beneficiario_sexo: parecerItem?.processo?.disparo?.beneficiario?.sexo === 'M' ? 'masculino' : 'feminino',
            beneficiario_guia: parecerItem?.processo?.disparo?.guia,
            beneficiario_nascimento: parecerItem?.processo?.disparo?.beneficiario?.nascimento,
            beneficiario_idade: tools.calcularIdade(parecerItem?.processo?.disparo?.beneficiario?.nascimento),
            auditor_nome: parecerItem?.processo?.disparo?.auditor?.nome,
            auditor_crmcro: parecerItem?.processo?.disparo?.auditor?.crm,
            auditor_uf: parecerItem?.processo?.disparo?.auditor?.uf,
            assistente_responsavel_nome: parecerItem?.processo?.disparo?.responsaveis?.nome_assistente,
            enfermeira_responsavel_nome: parecerItem?.processo?.disparo?.responsaveis?.nome_enfermeira,
            desempatador_responsavel_nome: parecerItem?.processo?.disparo?.responsaveis?.nome_desempatador,
            desempatador_responsavel_crmcro:
                parecerItem?.processo?.disparo?.responsaveis?.crm_desempatador ||
                parecerItem?.processo?.disparo?.responsaveis?.cro_desempatador,
            desempatador_responsavel_uf:
                parecerItem?.processo?.disparo?.responsaveis?.crm_uf_desempatador ||
                parecerItem?.processo?.disparo?.responsaveis?.cro_uf_desempatador,
            desempatador_responsavel_laudo: parecerItem?.processo?.disparo?.texto_parecer,
            data_parecer: moment(parecerItem?.processo?.disparo?.data_validacao).format('LL'),
            data_parecer_min: moment(parecerItem?.processo?.disparo?.data_validacao).format('DD/MM/YYYY'),
            procedimentos: (parecerItem?.processo?.disparo?.procedimentos || []).map((p) => {
                return {
                    id: p.id_procedimento,
                    codigo: p?.codigo || '-',
                    descricao: p.desc_procedimento,
                    quantidade_solicitada: p.quantidade_solicitada || 0,
                    quantidade_autorizada: p.quantidade_aprovada || 0,
                    quantidade_pos_analise: p.quantidade_pos_analise || 0,
                    id_divergencia: p.id_processo_motivo_divergencia,
                    divergencia: p?.desc_processo_motivo_divergencia || '-',
                    justificativa: p.observacao || '-',
                    justificativa_pos_analise: p.justificativa_analise || '-'
                };
            }),
            materiais: (parecerItem?.processo?.disparo?.materiais || []).map((m) => {
                return {
                    id: m.id_material,
                    descricao: m.desc_material,
                    quantidade_solicitada: m.quantidade_solicitada || 0,
                    quantidade_autorizada: m.quantidade_aprovada || 0,
                    quantidade_pos_analise: m.quantidade_pos_analise || 0,
                    id_divergencia: m.id_processo_motivo_divergencia,
                    divergencia: m?.desc_processo_motivo_divergencia || '-',
                    justificativa: m.observacao || '-',
                    justificativa_pos_analise: m.justificativa_analise || '-'
                };
            }),
            desempatadores: parecerItem?.processo?.disparo?.desempatadores,
            id_desempatador: parecerItem?.processo?.disparo?.responsaveis?.id_desempatador || 0,
            notificacao_envio: parecerItem?.processo?.disparo?.notificacao_envio || {},
            exames_complementares: [],
            conclusao: parecerItem?.processo?.processo_conclusao
        }
    } : {};

    return (
        <div>
            {loading ? (
                <div className="p-30 flex">
                    <Loading />{" "}
                    <span className="pl-10">Aguarde, carregando informações e montando dossiê...</span>
                </div>
            ) : (
                <div className="p-40">
                    <div className="float-right" id="no-print">
                        <button
                            className="btn btn-primary f700-16 jc-sb"
                            onClick={() => window.print()}
                        >
                            Imprimir <i className="icon icon-print rotate-180 i-20 ml-10" />
                        </button>
                    </div>
                    <br />
                    <div className="w-100 text-center pt-30 pb-10">
                        <h2 className="text-center fb-18">DOSSIÊ - ID: 231088{id_processo}</h2>
                    </div>
                    <div className="w-100">
                        <div className="text-right mb-10">
                            {moment(config.dataHoraAtual()).format('LL')}
                        </div>
                    </div>
                    <p className="text-justify">
                        Este dossiê apresenta um registro detalhado de todo o histórico do processo, do envio
                        de comunicações às partes envolvidas, como também a visualização integra destas
                        comunicações referentes ao processo de Junta Médica e/ou Odontológica de código
                        231088{id_processo}.
                    </p>
                    <br />
                    <p className="dossie-header-session">1. Resumo do processo (workflow):</p>
                    {(registro_historico || []).map((hd, i) => {
                        return (
                            <div key={i}>
                                <div className="w-100 fn-14 pv-10 pl-10 flex list-line">
                                    <div className="list-circle"></div>
                                    <div className="ml-25">
                                        <span className="mb-5 bold list-header">{hd.texto}</span>
                                        <br />
                                        <span className="mb-5">
                                            {" "}
                                            Etapa/status: {hd.desc_processo_etapa} | {hd.desc_processo_etapa_status}
                                        </span>
                                        <br />
                                        <b>Registro: {hd.data} hrs</b>
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                    <br />
                    <p className="dossie-header-session">
                        2. Registros de envio e leitura das comunicações:
                    </p>
                    {(registro_comunicacoes || []).map((nd, i) => {
                        return (
                            <div key={i}>
                                <div className="w-100 fn-14 pv-10 pl-10 flex list-line">
                                    <div className="list-circle"></div>
                                    <div className="ml-25">
                                        <span className="mb-5 bold">Conteúdo: {nd.texto}</span>
                                        <br />
                                        <span className="mb-5">Canal: {nd.canal}</span>
                                        <br />
                                        <span className="mb-5">Etapa: {nd.desc_processo_etapa}</span>
                                        <br />
                                        <span className="mb-5 bold">Envio: {nd.data_disparo} hrs</span>
                                        <br />
                                        <span className={`mb-5 bold ${nd.data_leitura && 'font-green'}`}>
                                            Leitura:{" "}
                                            {nd.data_leitura ? (
                                                <span className={`${nd.data_leitura && 'font-green'}`}>
                                                    {nd.data_leitura} hrs
                                                </span>
                                            ) : (
                                                "-"
                                            )}{" "}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                    <br />
                    <p className="dossie-header-session">
                        3. Registro geral de comunicações enviadas e seus conteúdos:
                    </p>
                    {(registro_comunicacoes || []).map((item, i) => {
                        return (
                            <div key={i} className="email-doc">
                                {item.id_notificacao_conteudo === '1' && (
                                    <ComAberturaJuntaBNF resp={item.processo} notify={item} viewHeader={true} print={true} />
                                )}
                                {item.id_notificacao_conteudo === '2' && (
                                    <ComAberturaJuntaPA
                                        resp={item.processo}
                                        notify={item}
                                        viewHeader={true}
                                        print={true}
                                        disabled={true}
                                    />
                                )}
                                {item.id_notificacao_conteudo === '3' && (
                                    <ComConsensoTecnicoOPS resp={item.processo} notify={item} viewHeader={true} print={true} />
                                )}
                                {item.id_notificacao_conteudo === '4' && (
                                    <ComDecisaoJuntaBNF resp={item.processo} notify={item} viewHeader={true} print={true} />
                                )}
                                {item.id_notificacao_conteudo === '5' && (
                                    <ComDecisaoJuntaPA resp={item.processo} notify={item} viewHeader={true} print={true} />
                                )}
                                {item.id_notificacao_conteudo === '6' && (
                                    <ComEscolhaAbstencaoBNF resp={item.processo} notify={item} viewHeader={true} print={true} />
                                )}
                                {item.id_notificacao_conteudo === '7' && (
                                    <ComEscolhaAbstencaoPA resp={item.processo} notify={item} viewHeader={true} print={true} />
                                )}
                                {item.id_notificacao_conteudo === '8' && (
                                    <ComEscolhaBNF resp={item.processo} notify={item} viewHeader={true} print={true} />
                                )}
                                {item.id_notificacao_conteudo === '9' && (
                                    <ComEscolhaPA resp={item.processo} notify={item} viewHeader={true} print={true} />
                                )}
                                {item.id_notificacao_conteudo === '10' && (
                                    <ParOpiniaoEspecializada resp={item.processo} notify={item} viewHeader={true} print={true} />
                                )}
                                {item.id_notificacao_conteudo === '13' && (
                                    <SolExamesComplementaresBNF resp={item.processo} notify={item} viewHeader={true} print={true} />
                                )}
                                {item.id_notificacao_conteudo === '14' && (
                                    <SolExamesComplementaresOPS resp={item.processo} notify={item} viewHeader={true} print={true} />
                                )}
                                {item.id_notificacao_conteudo === '15' && (
                                    <ValConsensoParcial resp={item.processo} notify={item} viewHeader={true} print={true} />
                                )}
                                {item.id_notificacao_conteudo === '17' && (
                                    <ComRecusaConsensoPA resp={item.processo} notify={item} viewHeader={true} print={true} />
                                )}
                                {item.id_notificacao_conteudo === '19' && (
                                    <ComConsensoTecnicoBNF resp={item.processo} notify={item} viewHeader={true} print={true} />
                                )}
                                {item.id_notificacao_conteudo === '20' && (
                                    <ComConsensoTecnicoPA resp={item.processo} notify={item} viewHeader={true} print={true} />
                                )}
                            </div>
                        );
                    })}
                    <br />
                    <p className="dossie-header-session">4. Registro de comunicações adicionais:</p>
                    {(registro_anexos || []).map((ad, i) => {
                        return (
                            <div key={i}>
                                <div className="w-100 fn-14 pv-10 pl-10 flex list-line">
                                    <div className="list-circle"></div>
                                    <div className="ml-25">
                                        <span className="mb-5 list-header">Tipo de documento: {ad.tipo}</span>
                                        <br />
                                        <span className="mb-5"> Canal de envio: {ad.canal}</span>
                                        <br />
                                        <span className="mb-5 bold font-green">Data de leitura: {ad.data} hrs</span>
                                        <br />
                                        <b>
                                            <span
                                                className="pointer link flex ai-gc"
                                                onClick={() => {
                                                    viewFile(ad, i);
                                                }}
                                            >
                                                {viewingIndex === i ? (
                                                    <div className="mr-5">
                                                        <Loading />
                                                    </div>
                                                ) : (
                                                    <i className="icon icon-add-document i-15 mr-5" />
                                                )}{" "}
                                                Visualizar documento
                                            </span>
                                        </b>
                                        <br />
                                        {ad.enviado_pa ? <span className="mb-5"><strong>* {ad.enviado_pa}</strong></span> : ''}
                                        <br />
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                    <br />
                    {![12, 42].includes(parseInt(id_processo_etapa_status)) && (
                        <div>
                            <p className="dossie-header-session">5. Registro de parecer técnico conclusivo:</p>
                            <div>
                                <div className="email-doc">
                                    <ParTecnicoConclusivo resp={registro_parecer.processo} print={true} />
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            )}
        </div>
    );
}
